import * as Utils from './utilities'
const TimelineLite = window.TimelineLite;
const Power3 = window.Power3;

const ANIMATION_COOKIE_ID = 'playedIntro';

export default (callback) => {
  const logo = document.querySelector('.logo');
  Utils.addClass( logo, 'logo--zoomed');

  const logoRect = logo.getBoundingClientRect();
  const logoCenter = {
    x: logoRect.left + document.body.scrollLeft + logoRect.width*0.5,
    y: logoRect.top + document.body.scrollTop + logoRect.height*0.5
  };
  const dx = (window.innerWidth*0.5) - logoCenter.x;
  const dy = (window.innerHeight*0.5) + logoCenter.y;

  const tl = new TimelineLite({
    onComplete: () => {
      callback();
    }
  });

  tl.fromTo( logo, 1, {
    x: dx,
    y: -dy,
    scaleX: 5.38,
    scaleY: 5.38,
    alpha: 0
  }, {
    alpha: 1
  });

  const duration = 2;
  const ease = Power3.easeInOut;

  tl.to( logo, duration, {
    opacity: 0,
    //y: 0, x: 0, scaleX: 1, scaleY: 1,
    ease
  }, 2);

  tl.from( document.body, duration, {
    y: window.innerHeight,
    ease
  }, 2);
  tl.call(()=>{
    document.body.removeAttribute('style');
    Utils.removeClass( logo, 'logo--zoomed');
  });
  tl.set( logo, {
    y: 0, x: 0, scaleX: 1, scaleY: 1
  });
  tl.to( logo, 1, {
    opacity: 1
  });

  const expiration = new Date((new Date()).getTime() + 1000*60*60*24);
  document.cookie = ANIMATION_COOKIE_ID + '=true; expires=' + expiration.toGMTString() + '; path=/';
}


/** WEBPACK FOOTER **
 ** ./src/js/intro-animation.js
 **/